import axios from "axios";
import { toast } from "react-toastify";
import authHeader from "./auth-header";

export const generateAgentSalesReport = (reportData) => {
  return axios
    .post(`${process.env.REACT_APP_BASE_URL}/salebill/agent-sales-report`, reportData, {
      headers: authHeader(),
    })
    .then((res) => {
      toast.success(res.data.msg);
      return res.data.data;
    })
    .catch((err) => {
      toast.error(err?.response?.data?.msg || "Error generating agent sales report");
      throw err;
    });
};

